import { apiRequest } from "../util/apiUtils";

export const productList = async (params) => {
  try {
    const res = await apiRequest("get", `product/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const productAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `product/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const productDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `product/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const productStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `product/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const productOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `product/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const productDetails = async (payload) => {
  try {
    const res = await apiRequest("get", `/product/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};
